function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.998 21.004h-1a3.001 3.001 0 01-3.002-3.002v-1M17.002 2.996h1a3.001 3.001 0 013.002 3.001v1M2.996 6.998v-1a3.001 3.001 0 013.001-3.002h1M21.004 17.002v1a3.001 3.001 0 01-3.002 3.002h-1M5.997 12V9A3.001 3.001 0 019 5.997H15A3.001 3.001 0 0118.003 9v3.002M18.003 15.001A3.001 3.001 0 0115 18.002H9a3.001 3.001 0 01-3.002-3.001M3.997 12h17.007",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgBarcodeScanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgBarcodeScanner;